import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Hammer, Calculator, Sparkles, X, ArrowRight } from 'lucide-react';

const DISMISS_KEY = 'atlas_module_suggestion_dismissed_v1';

const MODULE_META = {
  team: {
    icon: Hammer,
    title: 'Active le module Équipe',
    desc: 'Pointage GPS, contrôle horaire et checklists qualité — typique pour ton secteur. Tu peux gagner ~5K€/mois en contrôle horaire.',
    cta: 'Activer Équipe',
  },
  cfo: {
    icon: Calculator,
    title: 'Active le module CFO',
    desc: 'Cash-flow, BFR et garde-fou stratégique — ATLAS te ping avant que tu signes un contrat qui te fait couler.',
    cta: 'Activer CFO',
  },
  studio: {
    icon: Sparkles,
    title: 'Active le Studio Marketing',
    desc: 'Génération de posts LinkedIn et pitch decks par l\'IA, calibrés sur ton secteur.',
    cta: 'Activer Studio',
  },
};

const ModuleSuggestionBanner = () => {
  const { api, user } = useAuth();
  const navigate = useNavigate();
  const [suggestion, setSuggestion] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem(DISMISS_KEY) || '[]'); } catch { return []; }
  });

  useEffect(() => {
    let alive = true;
    api.get('/api/auth/modules')
      .then(r => {
        if (!alive) return;
        const enabled = r.data?.modules_enabled || {};
        const defaults = r.data?.sector_defaults || {};
        // Find module suggested ON by sector but currently OFF for user
        const candidate = Object.keys(defaults).find(k => defaults[k] === true && enabled[k] === false && !dismissed.includes(k));
        if (candidate) setSuggestion(candidate);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [api, dismissed]);

  const dismiss = () => {
    const next = [...dismissed, suggestion];
    localStorage.setItem(DISMISS_KEY, JSON.stringify(next));
    setDismissed(next);
    setSuggestion(null);
  };

  const activate = async () => {
    try {
      await api.put('/api/auth/modules', { [suggestion]: true });
      setSuggestion(null);
      // Force user refresh
      window.location.reload();
    } catch { /* noop */ }
  };

  if (!suggestion || !user) return null;
  const meta = MODULE_META[suggestion];
  if (!meta) return null;
  const Icon = meta.icon;

  return (
    <div data-testid="module-suggestion-banner" className="glass-card p-4 lg:p-5 border-l-4 border-l-atlasCyan flex items-start gap-3">
      <div className="w-10 h-10 rounded-lg bg-atlasCyan/15 flex items-center justify-center flex-shrink-0">
        <Icon className="w-5 h-5 text-atlasCyan" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-white font-semibold text-sm mb-1">{meta.title}</p>
        <p className="text-xs text-atlasTextSecondary leading-relaxed">{meta.desc}</p>
        <div className="flex items-center gap-3 mt-3">
          <button onClick={activate} data-testid="module-suggestion-activate" className="text-xs px-3 py-1.5 rounded-full bg-atlasCyan/15 text-atlasCyan hover:bg-atlasCyan/25 flex items-center gap-1 font-medium">
            {meta.cta}<ArrowRight className="w-3 h-3" />
          </button>
          <button onClick={() => navigate('/profile')} className="text-xs text-atlasTextSecondary hover:text-white">
            Gérer tous les modules
          </button>
        </div>
      </div>
      <button onClick={dismiss} data-testid="module-suggestion-dismiss" className="text-atlasTextSecondary hover:text-white p-1 flex-shrink-0" aria-label="Fermer">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ModuleSuggestionBanner;
